import DefaultLandOwnershipDetails from "src/components/feature/ProjectDetailView/LandOwnershipDetails";

const LandOwnershipDetails = () => {
  return <DefaultLandOwnershipDetails projectId={""} />;
};

export default LandOwnershipDetails;
